type HeaderMap = { [key: string]: string[]}
export const HEADERS: HeaderMap = {
  neoplasm: [
    'Malignant<br />Primary',
    'Malignant<br />Secondary',
    'Malignant<br />Ca in situ',
    'Benign',
    'Uncertain<br/>Behavior',
    'Unspecified'
  ],
  'drugs-chemicals': [
    'Poisoning,<br/>Accidental<br/>(unintentional)',
    'Poisoning,<br/>Intentional<br/>Self-Harm',
    'Poisoning,<br/>Assault',
    'Poisoning,<br/>Undetermined',
    'Adverse<br/>Effect',
    'Underdosing'
  ]
}